import { render, staticRenderFns } from "./LoadResumeSkeleton.vue?vue&type=template&id=4dcbf7e2&scoped=true"
import script from "./LoadResumeSkeleton.vue?vue&type=script&lang=js"
export * from "./LoadResumeSkeleton.vue?vue&type=script&lang=js"
import style0 from "./LoadResumeSkeleton.vue?vue&type=style&index=0&id=4dcbf7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcbf7e2",
  null
  
)

export default component.exports